import { BaseDto } from "@/shared/dtos/base-dto";
import { preguntas } from "./preguntas";
import { respuestas } from "./respuestas";

export class PreguntaRespuestaDto extends BaseDto {
  public preguntas: preguntas= new preguntas();;
  public respuestas:respuestas[]= [];
}
